import { ExportRow } from '@portal/shared/types/export.types';
import { notAvailable } from '@portal/shared/constants';
import { DeviceType } from 'src/app/pages/equipment/devices/components/devices.models';
import { devicesWithoutSerialNumber } from 'src/app/pages/equipment/devices/constants/devices.constants';
import { History, UpdateType } from '../services/history-api.types';
import { HistoryValues } from '../services/history-data.types';

export const mapHistoryToExport = (
  history: History,
  prepareValuesForExport: (values: HistoryValues, updateType: UpdateType) => string
): ExportRow => {
  const newValues = history.newValues ? JSON.parse(history.newValues) : null;
  const oldValues = history.oldValues ? JSON.parse(history.oldValues) : null;

  return {
    dateTimeUtcSet: { title: 'UpdatedDate/Time', value: history.dateTimeUtcSet },
    updateTypeName: { title: 'UpdateType', value: history.updateTypeName },
    merged: [
      {
        title: 'OldValue',
        value: oldValues ? prepareValuesForExport(oldValues, history.updateType) : notAvailable
      },
      {
        title: 'NewValue',
        value: newValues ? prepareValuesForExport(newValues, history.updateType) : notAvailable
      }
    ],
    deviceTypeName: { title: 'DeviceType', value: history.deviceTypeName ?? '' },
    modelName: { title: 'ModelName', value: history.modelName },
    commDeviceId: {
      title: 'CommDeviceID',
      value: history.commDeviceId ?? ''
    },
    serialNumber: {
      title: 'SerialNumber',
      value: devicesWithoutSerialNumber.includes(history.deviceType as DeviceType)
        ? ''
        : (history.serialNumber ?? 'Unknown Serial Number')
    },
    meterNumber: {
      title: 'InventoryID',
      value: history.meterNumber ?? ''
    },
    updatedBy: { title: 'UpdatedBy', value: history.updatedBy }
  };
};
